import { getBookingReservationApplicantDisplay } from './getBookingReservationApplicantDisplay';
import type {
  BookingReservationPartyLookup,
  BookingReservationRow,
} from '../Types/bookingReservationTable.types';

export interface BookingReservationFilters {
  applicantFilter: string;
  participantFilter: string;
}

export function filterBookingReservations(
  reservations: BookingReservationRow[],
  filters: BookingReservationFilters,
  parties: BookingReservationPartyLookup[]
): BookingReservationRow[] {
  const applicant = filters.applicantFilter.trim().toLowerCase();
  const participant = filters.participantFilter.trim().toLowerCase();

  if (!applicant && !participant) return reservations;

  return reservations.filter((row) => {
    if (applicant) {
      const title = getBookingReservationApplicantDisplay(row, parties).title.toLowerCase();
      if (!title.includes(applicant)) return false;
    }
    if (participant) {
      const hasMatch = (row.participants ?? []).some((p) =>
        `${p.firstName} ${p.lastName}`.toLowerCase().includes(participant)
      );
      if (!hasMatch) return false;
    }
    return true;
  });
}
